import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import Layout from "./Layout";
import PaywallGuard from "./PaywallGuard";
import TrialBanner from "./TrialBanner";
import { Clapperboard } from "lucide-react";

const ProtectedRoute = () => {
  const { user } = useAuth();

  if (user === undefined) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#0D0F12]">
        <div className="flex flex-col items-center gap-4">
          <Clapperboard size={40} className="text-amber-400 animate-pulse" />
          <p className="text-gray-400 text-sm tracking-widest uppercase">Loading Get2Set</p>
        </div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  return (
    <Layout>
      <TrialBanner />
      <PaywallGuard>
        <Outlet />
      </PaywallGuard>
    </Layout>
  );
};

export default ProtectedRoute;
